module.exports = __webpack_public_path__ + "star-classic.70211096b92eaca046db.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/star-classic.svg
// module id = ../../../../../src/assets/img/star-classic.svg
// module chunks = main